import { useMantineColorScheme } from '@mantine/core';
import { useEffect, useState } from 'react';
import c from './Landing.module.css';

const LINKS = [
  { href: '#work', label: 'Work' },
  { href: '#platform', label: 'What we do' },
  { href: '#toolkit', label: 'Toolkit' },
  { href: '#contact', label: 'Contact' },
];

export function Nav() {
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const dark = colorScheme !== 'light';
  const [open, setOpen] = useState(false);

  // Close the mobile menu on Escape and whenever the viewport grows past the phone breakpoint.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    const mq = window.matchMedia('(min-width: 761px)');
    const onResize = () => { if (mq.matches) setOpen(false); };
    window.addEventListener('keydown', onKey);
    mq.addEventListener('change', onResize);
    return () => {
      window.removeEventListener('keydown', onKey);
      mq.removeEventListener('change', onResize);
    };
  }, [open]);

  const themeButton = (
    <button
      type="button"
      className={c.themeBtn}
      title="Toggle theme"
      onClick={() => setColorScheme(dark ? 'light' : 'dark')}
    >
      {dark ? '☾ DARK' : '☀ LIGHT'}
    </button>
  );

  return (
    <nav className={`${c.container} ${c.nav}`}>
      <a href="#top" className={c.brand} aria-label="eXonstech home" onClick={() => setOpen(false)}>
        <span className={c.mark}><img className={c.logoImg} src="/logo.png" alt="" /></span>
        <span className={c.wordmark}>e<span>X</span>onstech</span>
        <span className={c.tagline}>AI CONSULTING &amp; ENGINEERING · TORONTO</span>
      </a>

      {/* Desktop links */}
      <div className={c.links}>
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} className={c.link}>{l.label}</a>
        ))}
        {themeButton}
      </div>

      {/* Phone: hamburger + dropdown panel */}
      <button
        type="button"
        className={`${c.burger} ${open ? c.burgerOpen : ''}`}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        aria-controls="mobile-menu"
        onClick={() => setOpen((o) => !o)}
      >
        <span />
        <span />
        <span />
      </button>
      <div id="mobile-menu" className={`${c.mobileMenu} ${open ? c.mobileMenuOpen : ''}`} aria-hidden={!open}>
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} className={c.mobileLink} onClick={() => setOpen(false)}>{l.label}</a>
        ))}
        <div className={c.mobileMenuFoot}>
          {themeButton}
          <a href="#contact" className={c.btnPrimary} onClick={() => setOpen(false)}>Start a project →</a>
        </div>
      </div>
    </nav>
  );
}
